<h2>Info</h2>
<h3><strong>{{train.type}} {{train.name}}</strong></h3>
<div class="train-info flex-col flex-gap-8">
  @for (inf of infoServices; track inf) {
    <div class="flex">
      <ng-container>
        @if (inf.image) {
          <img
            src="data:image/{{inf.image.type}};base64,{{inf.image.data}}"
            alt="{{inf.type}}"
            matTooltip="{{inf.type}}">
        }
        <span> {{inf.description}}</span>
      </ng-container>
    </div>
  }
  @if (infoNotes.length) {
    <h4><strong>Note informative</strong></h4>
  }
  @for (inf of infoNotes; track inf) {
    <div>
      - {{inf.description}}
    </div>
  }
</div>
@if (load || stops) {
  <h2>Fermate</h2>
}
@if (stops) {
  <div class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill" style="text-align: center">
    @for (s of stops; track s; let i = $index; let isFirst = $first; let isLast = $last) {
      <div class="train-info-stops fx-flex-15">
        <div class="fx-row">
          <div class="fx-flex-95">
            @if (s.arrival) {
              <div class=" train-info-time">{{s.arrival}}</div>
            }
            @if (!s.arrival && !(isFirst && train.departureLocalDateStr)) {
              <div class=" train-info-time null">null</div>
            }
            @if (isFirst && train.departureLocalDateStr) {
              <div class="train-info-time">{{train.departureLocalDateStr}}</div>
            }
            <div><span [ngClass]="i==0||i==stops.length-1?'ev':''">{{s.station}}</span></div>
            @if (s.departure) {
              <div class=" train-info-time">{{s.departure}}</div>
            }
            @if (!s.departure && !(isLast && train.arrivalLocalDateStr)) {
              <div class=" train-info-time null">null</div>
            }
            @if (isLast && train.arrivalLocalDateStr) {
              <div class="train-info-time">{{train.arrivalLocalDateStr}}</div>
            }
          </div>
          <div class="fx-flex-5">
            @if (i<stops.length-1) {
              <div class="train-info-stops-ico">
                <mat-icon id="arr">keyboard_arrow_right</mat-icon>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
@if (load) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
